/* 判断各个浏览器版本号 */
function matchVesion() {
  const userAgent = navigator.userAgent
  const rMsie = /(msie\s|trident.*rv:)([\w.]+)/
  const rEdge = /(edg)\/([\w.]+)/
  const rFirefox = /(firefox)\/([\w.]+)/
  const rOpera = /(opera).+version\/([\w.]+)/
  const rChrome = /(chrome)\/([\w.]+)/
  const rSafari = /version\/([\w.]+).*(safari)/
  const ua = userAgent.toLowerCase()
  const match = rMsie.exec(ua)
  if (match !== null) {
    return { browser: 'IE',
      version: match[2] || '0' }
  }
  const rEmatch = rEdge.exec(ua)
  if (rEmatch !== null) {
    return { browser: 'Edge',
      version: rEmatch[2] || '0' }
  }
  const rFmatch = rFirefox.exec(ua)
  if (rFmatch !== null) {
    return { browser: rFmatch[1] || '',
      version: rFmatch[2] || '0' }
  }
  const rOmatch = rOpera.exec(ua)
  if (rOmatch !== null) {
    return { browser: rOmatch[1] || '',
      version: rOmatch[2] || '0' }
  }
  const rCmatch = rChrome.exec(ua)
  if (rCmatch !== null) {
    return { browser: rCmatch[1] || '',
      version: rCmatch[2] || '0' }
  }
  const rSmatch = rSafari.exec(ua)
  if (rSmatch !== null) {
    return { browser: rSmatch[2] || '',
      version: rSmatch[1] || '0' }
  }
  if (match !== null) {
    return { browser: '',
      version: '0',
    }
  }
}
  
export function initBrowserVersion() {
  const browserMatch = matchVesion()
  return browserMatch
}
